
const WodaMieszkancySeryjneSelect = props => {

    const { rozliczenieWody, setWybraneRozliczenie } = props;

    const handleRozliczenie = e => setWybraneRozliczenie( rozliczenieWody?.find( r => r?.id == e?.target.value)  );

    const listaRozliczen = rozliczenieWody?.map( (rozliczenie, i) => {

        return (
            <option 
                key={i}
                value={rozliczenie?.id}
            >
                { rozliczenie?.opis }
            </option>
        )
    })

    return (
        <select
            onChange={handleRozliczenie}
        >
            <option>
                Wybierz rozliczenie:
            </option>
            {listaRozliczen}
        </select>
    )
}

export default WodaMieszkancySeryjneSelect;